import { defineStore } from "pinia";
import type { INews, ICalendar, IAfishaItem, ICareSlide, IOurPeople, IVideoInterview, IFactoryGuidSlides, IBaseEntity } from "@/interfaces/IEntities";
import type { MainPageCards } from "@/interfaces/IMainPage";
import type { IReaction } from "@/interfaces/IEntities";

export interface DataState {
    homeData: MainPageCards,
    ourPeopleData: IOurPeople[],
    actualNewsData: INews[],
    corpEventsData: INews[],
    corpLifeData: IBaseEntity[],
    afishaData: IAfishaItem[],
    careData: ICareSlide[],
    videoInterviewsData: IVideoInterview[],
    videoReportsData: INews[],
    corpNewsData: INews[],
    officialEventsData: IBaseEntity[],
    partnerBonusData: IBaseEntity[],
    calendarData: ICalendar[],
    factoryGuidData: IFactoryGuidSlides[],
    filmsEmk: IBaseEntity[],
    // yearResultsData: any[];
    // blogsData: any[];
    // gazettesData: any[],
}

export type DataStateKey = keyof DataState;

export const useViewsDataStore = defineStore('viewsData', {
    state: (): DataState => ({
        homeData: [],
        ourPeopleData: [],
        videoInterviewsData: [],
        actualNewsData: [],
        corpNewsData: [],
        videoReportsData: [],
        officialEventsData: [],
        corpEventsData: [],
        corpLifeData: [],
        afishaData: [],
        partnerBonusData: [],
        careData: [],
        calendarData: [],
        factoryGuidData: [],
        filmsEmk: [],
        // yearResultsData: [],
        // blogsData: [],
        // gazettesData: any[],
    }),

    actions: {
        setData<T extends DataStateKey>(fetchedData: DataState[T], dataType: T): void {
            if (this[dataType]) {
                (this[dataType] as DataState[T]) = fetchedData;
            }
        },
        setHomeNewReactions(BlockId: number, elementId: number, newReaction: IReaction) {
            const targetBlock = this.homeData.find(e => e.id == BlockId)?.images
            if (!targetBlock) return
            const targetElement = targetBlock.find(e => e.id == elementId)
            if (!targetElement) return
            targetElement.reactions = newReaction
        }
    },

    getters: {
        getData: (state) => (dataType: DataStateKey) => {
            return state[dataType]
        }
    }
});